module.exports = __webpack_public_path__ + "img/01-1商情诊断管理分析.a7327410.png";